var map = {
	"./MTABAPP6MWT.svg": "d0c0",
	"./MTABAPPABI.svg": "48bd",
	"./MTABAPPABP.svg": "4556",
	"./MTABAPPADBP.svg": "9720",
	"./MTABAPPBP.svg": "ad49",
	"./MTABAPPDBP.svg": "0cda",
	"./MTABAPPDCBP.svg": "f88b",
	"./MTABAPPECG.svg": "6ff0",
	"./MTABAPPFEV6.svg": "c630",
	"./MTABAPPPHOTO.svg": "316b",
	"./MTABAPPPROTOCOL.svg": "d0f7",
	"./MTABAPPPWV.svg": "062b",
	"./MTABAPPSPIRO+.svg": "be6d",
	"./MTABAPPSPIRO.svg": "4060",
	"./MTABAPPSPO2.svg": "fd6f",
	"./MTABAPPTBI.svg": "6bf2",
	"./MTABAPPTEMP.svg": "ab35",
	"./MTABAPPVITALS.svg": "c3aa",
	"./MTABAPPWL.svg": "d0ce"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9a6b";